var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-05"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.5 2.26953V6.40007C14.5 6.96012 14.5 7.24015 14.609 7.45406C14.7049 7.64222 14.8578 7.7952 15.046 7.89108C15.2599 8.00007 15.5399 8.00007 16.1 8.00007H20.2305M14.5 17H8.5M16.5 13H8.5M20.5 9.98822V17.2C20.5 18.8802 20.5 19.7202 20.173 20.362C19.8854 20.9265 19.4265 21.3854 18.862 21.673C18.2202 22 17.3802 22 15.7 22H9.3C7.61984 22 6.77976 22 6.13803 21.673C5.57354 21.3854 5.1146 20.9265 4.82698 20.362C4.5 19.7202 4.5 18.8802 4.5 17.2V6.8C4.5 5.11984 4.5 4.27976 4.82698 3.63803C5.1146 3.07354 5.57354 2.6146 6.13803 2.32698C6.77976 2 7.61984 2 9.3 2H12.5118C13.2455 2 13.6124 2 13.9577 2.08289C14.2638 2.15638 14.5564 2.27759 14.8249 2.44208C15.1276 2.6276 15.387 2.88703 15.9059 3.40589L19.0941 6.59411C19.613 7.11297 19.8724 7.3724 20.0579 7.67515C20.2224 7.94356 20.3436 8.2362 20.4171 8.5423C20.5 8.88757 20.5 9.25445 20.5 9.98822Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon_history.bad4d9c2c5f3b86f86843081e15a931a.svg";
export { ForwardRef as ReactComponent };